import { createUseStyles } from "react-jss";
import { SPACING } from "../../../constants/styleGuide";
const ViewProductStyles = createUseStyles({
    leftContent: {
        paddingRight: SPACING.s72,
        paddingTop: 10
    },
    rightContent: {
        paddingTop: 10,
        paddingLeft: SPACING.s24,
        paddingRight: SPACING.s24,
    },
    inputHeight: {
        minHeight: "100px"
    },
    matterTypeContainer:{
        paddingRight: SPACING.s24,
    },
    contentSpacing8: {
        paddingTop: SPACING.s8,
    },
    contentSpacing10: {
        paddingTop: SPACING.s10,
    },
    switchAlignment: {
        paddingTop: SPACING.s16,
        paddingBottom: SPACING.s16,
        float: "left",
        width: "50%"
    },
    contentSpacing24: {
        paddingTop: SPACING.s24,
    },
    contentSpacing48: {
        paddingTop: SPACING.s48,
    },
    info: {
        marginLeft: SPACING.s10,
    },
    startDatePicker: {
        paddingTop: SPACING.s10,
        paddingLeft: SPACING.s16,
    },
    endDatePicker: {
        paddingTop: SPACING.s10,
    },
    header: {
        width: '133px',
        height: '24px',
        flexGrow: 0,
        fontSize: '16px',
        fontWeight: 'bold',

    },
    tag: {
        padding: SPACING.s4,
    },
    tagClose: {
        "&:hover": {
            cursor: "pointer",
        },
    },
    displayNone: {
        display: 'none'
    },
    pageContent: {
        backgroundColor: "#FFF",
        borderRadius: "10px",
        padding: '32px 40px',
        border: "solid 2px #eee",
    },
    paddingRight36: {
        paddingRight: "36px",
    },
    contentSpacing16: {
        paddingTop: SPACING.s16,
    },
    switchAlignment: {
        paddingTop: SPACING.s30,
        paddingBottom: SPACING.s30,
        float: "left",
        width: "100%"
    },
    labelTitle: {
        fontSize: "14px",
        fontFamily: "Bogle",
        fontWeight: 'bold',
        paddingBottom: "16px"
    },
    pageContainer: {
        backgroundColor: '#F5F5F5',
        padding: '32px 40px',
        height: '100%',
    },
    sectionCard: {
        backgroundColor: "#FFF",
        borderRadius: "12px",
        padding: "32px",
        border: "1px solid #e6e7e8",
        marginBottom: "20px",
        boxShadow: "0 1px 3px rgba(0, 0, 0, 0.08)",
    },
    sectionTitle: {
        display: 'flex',
    alignItems: 'center',
    gap: '8px',
    fontSize: '11px',
    fontWeight: 700,
    color: '#475569',
    textTransform: 'uppercase',
    letterSpacing: '0.08em',
    marginTop: '32px',
    marginBottom: '20px',
    paddingBottom: '12px',
    lineHeight: '1',
    borderBottom: '1px solid #E2E8F0',
    '&:first-of-type': {
      marginTop: '0'
    },
    '& svg': {
      fontSize: '16px',
      color: '#64748B'
    }
    },
    sectionGrid: {
        display: "grid",
        gridTemplateColumns: "1fr 1fr 1fr 1fr",
        gap: "20px 64px",
    },
    sectionGridContainer: {
        rowGap: '20px',
    },
    fieldContainer: {
        marginBottom: "4px",
        paddingRight: "36px",
    },
    fieldLabel: {
        fontSize: "14px",
        fontWeight: "400",
        color: "#2e2f32",
        marginBottom: "4px",
        fontFamily: "Bogle, sans-serif",
        textTransform: "none",
        letterSpacing: "normal",
    },
    fieldValue: {
        fontSize: "14px",
        fontWeight: "700",
        color: "#2e2f32",
        lineHeight: "1.5",
        fontFamily: "Bogle, sans-serif",
    },
    fieldValueEmpty: {
        fontSize: "14px",
        fontWeight: "400",
        color: "#74767c",
        fontFamily: "Bogle, sans-serif",
        fontStyle: "italic",
    },
    notesBox: {
        backgroundColor: "#f9fafb",
        borderRadius: "6px",
        padding: "16px",
        minHeight: "80px",
        fontSize: "14px",
        color: "#2e2f32",
        border: "1px solid #e5e7eb",
        lineHeight: "1.5",
        fontFamily: "Bogle, sans-serif",
    },
    switchAlignmentInSection: {
        display: "flex",
        alignItems: "center",
        paddingTop: SPACING.s16,
        gap: SPACING.s16,
    },
    headerContainer: {
        borderBottom: "1px solid #e5e7eb",
        marginBottom: "24px",
    },
    breadcrumb: {
        fontSize: "14px",
        color: "#74767c",
        marginBottom: "16px",
        fontFamily: "Bogle, sans-serif",
    },
    headerRow: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start",
        paddingBottom: "12px",
    },
    headerLeft: {
        display: "flex",
        flexDirection: "column",
    },
    headerTitleRow: {
        display: "flex",
        alignItems: "center",
        gap: "12px",
        marginBottom: "8px",
    },
    headerTitle: {
        fontSize: "24px",
        fontWeight: "700",
        color: "#2e2f32",
        margin: 0,
        fontFamily: "Bogle, sans-serif",
    },
    actionButtons: {
        display: "flex",
        justifyContent: "flex-end",
    },
});

export default ViewProductStyles;